webpackJsonp([13],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_header_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_slidebar_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer_vue__ = __webpack_require__(19);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    headerPage: __WEBPACK_IMPORTED_MODULE_0__components_layout_header_vue__["a" /* default */],
    navbarPage: __WEBPACK_IMPORTED_MODULE_1__components_layout_slidebar_vue__["a" /* default */],
    footerPage: __WEBPACK_IMPORTED_MODULE_2__components_layout_footer_vue__["a" /* default */]
  }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.a91c98e.png";

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(24);


var ManageFile = function ManageFile() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 40));
};
var DetailFile = function DetailFile() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 41));
};
var BillDetail = function BillDetail() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 42));
};
var ImagePreview = function ImagePreview() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 43));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 44));
};
var Report = function Report() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 45));
};
var Email = function Email() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 46));
};
var Storage = function Storage() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 47));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 48));
};
var Addmail = function Addmail() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 49));
};
var NewBill = function NewBill() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 50));
};
var NewReport = function NewReport() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 51));
};
var Page404 = function Page404() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 52));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: ManageFile
  }, {
    path: '/bill/:key',
    name: 'Detail',
    component: DetailFile
  }, {
    path: '/detail/:key',
    name: 'BillDetail',
    component: BillDetail
  }, {
    path: '/addmail/:key',
    name: 'Addmail',
    component: Addmail
  }, {
    path: '/images/:key/:id',
    name: 'ImagePreview',
    component: ImagePreview
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/report',
    name: 'report',
    component: Report
  }, {
    path: '/profile',
    name: 'profile',
    component: Profile
  }, {
    path: '/addFolder',
    name: 'addFolder',
    component: NewBill
  }, {
    path: '/email',
    name: 'Email',
    component: Email
  }, {
    path: '/storage',
    name: 'storage',
    component: Storage
  }, {
    path: '/newreport',
    name: 'newreport',
    component: NewReport
  }, {
    path: '*',
    component: Page404
  }]
}));

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Vuex_store__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_index_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_ipad_css__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_ipad_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__css_ipad_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_iphone5_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_iphone5_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_iphone5_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_iphone678_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_iphone678_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_iphone678_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_iphoneX_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_iphoneX_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_iphoneX_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_iphonePlus_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_iphonePlus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__css_iphonePlus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_social_sharing__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_social_sharing__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_3__Vuex_store__["a" /* default */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_app_js__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cec7b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(23);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cec7b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eacc4ad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(15);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eacc4ad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"topbar"},[_c('nav',{staticClass:"navbar top-navbar navbar-expand-md navbar-light"},[_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.user.username != null),expression:"$store.state.user.username != null"}],staticClass:"navbar-collapse"},[_vm._m(1),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.user.username != null),expression:"$store.state.user.username != null"}],staticClass:"navbar-nav my-lg-0"},[_c('li',{staticClass:"nav-item dropdown"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right scale-up"},[_c('ul',{staticClass:"dropdown-user"},[_c('li',[_c('div',{staticClass:"dw-user-box"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"u-text p-t-10"},[_c('h4',[_vm._v(_vm._s(_vm.$store.state.user.username))]),_vm._v(" "),_c('a',{staticClass:"btn btn-rounded btn-danger btn-sm",attrs:{"href":"javascript:(0)"}},[_vm._v(_vm._s(_vm.$store.state.user.role_name))])])])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push({ name: 'profile'})}}},[_c('i',{staticClass:"ti-user"}),_vm._v(" My Profile")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$store.commit('logout')}}},[_c('i',{staticClass:"fa fa-power-off"}),_vm._v(" Logout")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(16),"alt":"homepage"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav mr-auto mt-md-0"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark",staticStyle:{"font-size":"35px"},attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"mdi mdi-menu"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link dropdown-toggle text-muted waves-effect waves-dark",attrs:{"href":"","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"profile-pic",attrs:{"src":__webpack_require__(4),"alt":"user"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-img"},[_c('img',{attrs:{"src":__webpack_require__(4),"alt":"user"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-light-icon.6fe73a0.png";

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b66642a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slidebar_vue__ = __webpack_require__(18);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b66642a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-sidebar"},[_c('div',{staticClass:"scroll-sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{attrs:{"id":"sidebarnav"}},[_c('li',{class:{ 'active': _vm.$route.name == 'Home' },on:{"click":function($event){return _vm.$router.push({ name: 'Home' })}}},[_vm._m(0)]),_vm._v(" "),_c('li',{class:{ 'active': _vm.$route.name == 'addFolder' },on:{"click":function($event){return _vm.$router.push({ name: 'addFolder' })}}},[_vm._m(1)]),_vm._v(" "),_c('li',{class:{ 'active': _vm.$route.name == 'Email' },on:{"click":function($event){return _vm.$router.push({ name: 'Email' })}}},[_vm._m(2)]),_vm._v(" "),_c('li',{class:{ 'active': _vm.$route.name == 'report' },on:{"click":function($event){return _vm.$router.push({ name: 'report' })}}},[_vm._m(3)]),_vm._v(" "),_c('li',{class:{ 'active': _vm.$route.name == 'storage' },on:{"click":function($event){return _vm.$router.push({ name: 'storage' })}}},[_vm._m(4)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-folder-open-o",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Manage Folder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Add Folder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Search Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Report")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-pie-chart",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("Storage Management")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9e1cb40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(22);
function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9e1cb40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[(_vm.$store.state.uploads.length > 0)?_c('div',{staticClass:"alert alert-light",staticStyle:{"width":"250px"},attrs:{"role":"alert","id":"alert"}},[_c('i',{staticClass:"fa fa-cloud-upload",attrs:{"aria-hidden":"true"}}),_vm._v(" Status Upload: \n    "),_vm._l((_vm.$store.state.uploads),function(up,index){return _c('div',{key:index,staticStyle:{"margin-top":"5px","text-align":"left"}},[_vm._v("\n      Bill: "+_vm._s(up.id)+"\n      "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-dark",style:({ 'width': up.status + '%'}),attrs:{"role":"progressbar","aria-valuenow":up.status,"aria-valuemin":"0","aria-valuemax":"100"}},[(up.status != 100)?_c('span',[_vm._v(_vm._s(up.status)+"%")]):_vm._e(),_vm._v(" "),(up.status == 100)?_c('span',[_vm._v("Please Wait . . . .")]):_vm._e()])])])})],2):_vm._e(),_vm._v("\n  © PhotoGenius Contact us. "),_c('a',{attrs:{"href":"mailto:maerimelephantphoto@gmail.com","title":"Mail","target":"_blank","data-original-title":"Mail"}},[_vm._v("maerimelephantphoto@gmail.com")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"preloader"},[_c('svg',{staticClass:"circular",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])]),_vm._v(" "),_c('headerPage'),_vm._v(" "),_c('navbarPage',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.user.username != null),expression:"$store.state.user.username != null"}],staticStyle:{"margin-top":"15px"}}),_vm._v(" "),_c('div',{attrs:{"id":"main-wrapper"}},[_c('main',{staticClass:"container",staticStyle:{"padding-top":"150px","overflow":"auto","padding-bottom":"50px","text-align":"center"}},[_c('router-view')],1),_vm._v(" "),_c('footerPage')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(27);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: {
    username: null,
    role_name: null,
    token: null
  },
  url: location.protocol + '//' + window.location.hostname,
  // url: 'https://photo.extensionsoft.biz',
  // url: 'http://188.166.254.123',
  os: null,
  config: null,
  uploads: []
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["sigin"] = sigin;
/* harmony export (immutable) */ __webpack_exports__["checkLogin"] = checkLogin;
/* harmony export (immutable) */ __webpack_exports__["setConfig"] = setConfig;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(5);



function sigin(state, data) {
  state.user.username = data.username;
  state.user.role_name = data.role_name;
  state.user.token = data.accesstoken;
  sessionStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.user));
}

function checkLogin(state) {
  if (state.user.username === null && sessionStorage.getItem('users') === null && sessionStorage.getItem('config') === null) {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
      name: 'Login'
    });
  } else {
    state.user = JSON.parse(sessionStorage.getItem('users'));
    state.config = JSON.parse(sessionStorage.getItem('config'));
  }
}

function setConfig(state, data) {
  state.config = data.config;
  sessionStorage.setItem('config', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.config));
}

function logout(state) {
  state.user.username = null;
  state.user.role_name = null;
  state.config = null;
  sessionStorage.clear();
  if (state.user.username === null) {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
      name: 'Login'
    });
  }
}

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.911aa22272935e0c3770.js